import { render, staticRenderFns } from "./RevenueByProduct.vue?vue&type=template&id=458463cb&scoped=true&lang=pug"
import script from "./RevenueByProduct.vue?vue&type=script&lang=js"
export * from "./RevenueByProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458463cb",
  null
  
)

export default component.exports